<template>
  <div id="app">
    <div class="content-wrapper">
      <router-view keepalive></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html, body{
  position: relative;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue